/*
 *
 * TenantForm14691
 *
 */

import {TenantForm} from 'pages/Requests/TenantView';
import {CREATED} from 'domain/Data/RequestStatus/constants';
import {
    ON_CAR_ENTRY, ON_PASS_MAKING,
    ON_PROPERTY_BRINGING,
    ON_PROPERTY_REMOVAL,
    ON_VISIT,
    SERVICE,
    CARRYING_OUT_WORKS,
} from 'domain/Data/RequestType/constants';
import {accessLevel} from '../../../domain/Data/VozdvizhenkaAccessLevel/constants';
import {validateCarNumber} from 'utils/validators';
import {formField} from 'domain/typeConstants/form';
import * as entities from 'domain/Data/constants';
import {WITH_CHIP, WITHOUT_CHIP} from 'domain/Data/PassType/constants';
import {calculateMaxExpirationDate, validateExpirationDate} from '../utils';
import {groupRequestVisitorsDataHelperText, visitorFullNameLabel} from 'pages/Requests/common/fields';
import {helperTextClassName} from "../common/formClassNames";

export class TenantForm14691 extends TenantForm {

    getClassNames() {
        return {
            helperText: helperTextClassName,
        };
    }

    getFields() {
        const currentDate = new Date();

        return [
            {
                name: 'author',
                visible: false,
                initialValue: (values, mode, user) => user.id,
            },
            {
                name: 'customer',
                visible: false,
                initialValue: (values, mode, user) => user.id,
            },
            {
                cached: false,
                type: 'select',
                entityName: 'companies',
                name: 'company',
                label: 'Арендатор',
                visible: false,
                initialValue: (values, mode, user) => user.companyId,
                numberInQueueFromEnd: 1,
            },
            {
                name: 'arrivalDate',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'departureDate',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'passNumber',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'number',
                label: '№',
                visible: (currentValues, initialValues, mode) => mode === 'view',
            },
            {
                name: 'status',
                type: 'select',
                label: 'Статус',
                entityName: 'requestStatuses',
                visible: (currentValues, initialValues, mode) => mode === 'view',
                initialValue: CREATED,
                orderBy: 'name',
            },
            {
                name: 'type',
                type: 'select',
                label: 'Вид',
                required: true,
                entityName: 'requestTypes',
                filters: ['AvailableRequestsTypes14691'],
                orderBy: 'order',
                initialValue: (values, mode, user) => {
                    if (mode === 'add' && user.defaultRequestTypeId) {
                        return user.defaultRequestTypeId;
                    }
                    return values.type;
                },
                clearErrorsOnChange: true,
                helperText: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL ?
                    'Въезд во внутренний двор только для разгрузки продолжительностью не более 1 часа' : null,
            },
            {
                name: 'longterm',
                type: 'checkbox',
                label: (values) => values.type === ON_PASS_MAKING ? 'Срок действия' : 'Долгосрочная',
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'visitDate',
                type: 'date',
                label: 'Дата',
                required: true,
                visible: true,
                initialValue: currentDate,
                rowBreakBefore: (currentValues, initialValues, mode) => mode !== 'view',
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate ?
                    new Date(initialValues.visitDate) : currentDate,
                calculatedValue: (values) => {
                    const visitDate = new Date(values.visitDate);
                    return new Date(visitDate.getFullYear(), visitDate.getMonth(), visitDate.getDate(), currentDate.getHours()
                    )
                },
            },
            {
                name: 'expirationDate',
                type: 'date',
                label: 'Дата окончания',
                required: (values) => values.longterm,
                visible: (values) => values.longterm && values.type !== SERVICE,
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        return new Date(values.expirationDate) > currentDate ?
                            new Date(values.expirationDate) : currentDate;
                    }
                    return null;
                },
                calculatedValue: (values) => values.longterm ? values.expirationDate : null,
                min: (values) => new Date(values.visitDate) < currentDate ?
                    new Date(values.visitDate) : currentDate,
                validate: validateExpirationDate,
                max: calculateMaxExpirationDate,
            },
            {
                name: 'isGroupRequest',
                type: 'checkbox',
                label: 'Групповая заявка',
                visible: (values) => values.type === ON_VISIT || values.type === ON_CAR_ENTRY || values.type === CARRYING_OUT_WORKS,
                rowBreakBefore: true,
            },
            {
                name: 'groupRequestVisitorsData',
                label: 'Список посетителей',
                multiline: true,
                helperText: groupRequestVisitorsDataHelperText(),
                visible: (values) => values.isGroupRequest && values.type !== SERVICE,
                required: (values) => values.isGroupRequest && values.type === ON_VISIT,
                grid: {sm: 12},
                rowBreakBefore: true,
            },
            {
                name: 'vozdvizhenkaTime',
                type: formField.SELECT,
                entityName: entities.TIMES,
                label: 'Время доступа',
                visible: (values) => values.type === ON_PASS_MAKING || values.type === CARRYING_OUT_WORKS,
                required: (values) => values.type === ON_PASS_MAKING,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'workType',
                label: 'Вид',
                type: formField.SELECT,
                entityName: entities.WORK_TYPES,
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'visitorFullName',
                label: visitorFullNameLabel,
                type: 'dadata',
                dadataType: 'NAME',
                dadataParts: ['SURNAME', 'NAME', 'PATRONYMIC'],
                visible: (values) => !values.isGroupRequest && values.type !== SERVICE && values.type !== CARRYING_OUT_WORKS,
                autoFocus: (currentValues, initialValues, mode) => mode === 'add',
                required: (values) => (!values.isGroupRequest && values.type === ON_VISIT)
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                rowBreakBefore: true,
            },
            {
                name: 'companyName',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Подрядчик' : 'Из какой компании',
                visible: true,
                required: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
            },
            {
                name: 'responsibleFromContractor',
                label: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL
                    ? 'Телефон водителя' : 'Ответственный от подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: true,
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'responsibleFromContractorPhone',
                label: (values) => values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL
                    ? 'Телефон ответственного (заявителя)' : 'Телефон отв. подрядчика',
                visible: (values) => values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: true,
            },
            {
                name: 'issueReason',
                type: formField.SELECT,
                entityName: entities.ISSUE_REASONS,
                label: 'Причина выдачи',
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.type === ON_PASS_MAKING,
                orderBy: 'id',
            },
            {
                name: 'passType',
                type: 'select',
                label: 'Вид пропуска',
                entityName: 'passTypes',
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.type === ON_PASS_MAKING,
                visibleOptions: () => [WITH_CHIP, WITHOUT_CHIP],
            },
            {
                name: 'nonstandardCarNumber',
                type: 'checkbox',
                label: 'Нестандартный № авто',
                rowBreakBefore: (values) => values.type === CARRYING_OUT_WORKS,
                rowBreakAfter: true,
                visible: (values) => (values.type === ON_CAR_ENTRY || values.type === ON_PROPERTY_BRINGING
                    || values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS) && !values.isGroupRequest,
            },
            {
                name: 'carNumber',
                label: '№ автомобиля',
                required: (values) => values.type === ON_CAR_ENTRY && !values.isGroupRequest,
                visible: (values) => (values.type === ON_CAR_ENTRY ||
                    values.type === ON_PROPERTY_BRINGING ||
                    values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS) && !values.isGroupRequest,
                normalize: (value) => value ? value.replace(' ', '') : value,
                validate: validateCarNumber,
                rowBreakBefore: true,
            },
            {
                name: 'carModelText',
                label: 'Марка и модель авто',
                visible: (values) => (values.type === ON_CAR_ENTRY ||
                    values.type === ON_PROPERTY_BRINGING ||
                    values.type === ON_PROPERTY_REMOVAL || values.type === CARRYING_OUT_WORKS) && !values.isGroupRequest,
                required: (values) => values.carNumber && (values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL)
            },
            {
                name: 'vozdvizhenkaAccessLevel',
                type: formField.SELECT,
                entityName: entities.VOZDVIZHENKA_ACCESS_LEVEL,
                label: (values) => values.type === ON_PASS_MAKING ? 'Уровень доступа' : 'Пронос через дебаркадер',
                visible: (values) => values.type === ON_PASS_MAKING || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                required: (values) => values.type === ON_PASS_MAKING || values.type === ON_PROPERTY_BRINGING || values.type === ON_PROPERTY_REMOVAL,
                visibleOptions: (values) => values.type === ON_PASS_MAKING ? [accessLevel.TOURNIQUET, accessLevel.ADDITIONAL]
                    : [accessLevel.YES, accessLevel.NO],
                orderBy: 'id',
            },
            {
                name: 'vodvizhenkaAccessRight',
                label: 'Дополнительный доступ',
                multiline: true,
                visible: (values) => values.type === ON_PASS_MAKING,
                required: (values) => values.vozdvizhenkaAccessLevel === accessLevel.ADDITIONAL,
                rowBreakBefore: true,
            },
            {
                name: 'parking',
                type: 'select',
                label: 'Парковка',
                entityName: 'parkings',
                visible: (values) => values.type === ON_CAR_ENTRY,
            },
            {
                name: 'parkingPlace',
                label: 'Место парковки',
                visible: false,
                initialValue: () => null,
            },
            {
                name: 'materialValuesData',
                label: 'Данные мат. ценностей',
                helperText: 'наименование, кол-во, ед.изм.',
                grid: {sm: 12},
                required: true,
                visible: (values) => values.type === ON_PROPERTY_BRINGING ||
                    values.type === ON_PROPERTY_REMOVAL,
            },
            {
                name: 'whoMeets',
                label: 'Кто встречает',
                visible: (values) => values.type === ON_VISIT,
                rowBreakBefore: true,
            },
            {
                name: 'service',
                type: 'select',
                label: 'Сервис',
                entityName: 'services',
                visible: (values) => values.type === SERVICE,
                rowBreakBefore: true,
            },
            {
                name: 'whereHappened',
                label: 'Где произошло',
                entityName: 'services',
                visible: (values) => values.type === SERVICE,
            },
            {
                name: 'whatHappened',
                label: (values) => values.type === CARRYING_OUT_WORKS ? 'Наименование/Характер работ' : 'Что нужно сделать',
                multiline: false,
                visible: (values) => values.type === SERVICE || values.type === CARRYING_OUT_WORKS,
                grid: {sm: 12},
            },
            {
                name: 'assignee',
                type: 'select',
                label: 'Исполнитель',
                entityName: 'employees',
                orderBy: 'name',
                cached: false,
                visible: (currentValues, initialValues, mode) => currentValues.type === SERVICE && (mode === 'view' || mode === 'edit'),
                rowBreakAfter: (values) => values.type === SERVICE,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.assignee;
                },
                visibleOptions: (currentValues, initialValue, mode, user, entities) => {
                    const assignee = [];
                    entities.get('employees').map((item) => {
                        if (item.company === user.companyId && item.isPerformer) assignee.push(item.id);
                    });

                    return assignee;
                },
                disabled: (currentValues, initialValues, mode) => mode === 'view' || mode === 'edit',
            },
            {
                name: 'executionDate',
                type: 'date',
                label: 'Дата выполнения факт',
                required: true,
                visible: (currentValues, initialValues, mode) => currentValues.type === SERVICE && (mode === 'view' || mode === 'edit'),
                min: (currentValues, initialValues) => new Date(initialValues.visitDate) < currentDate
                    ? new Date(initialValues.visitDate) : currentDate,
                rowBreakBefore: true,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionDate;
                },
                disabled: (currentValues, initialValues, mode) => mode === 'view' || mode === 'edit',
            },
            {
                name: 'executionTerm',
                type: 'date',
                label: 'Срок исполнения',
                required: true,
                visible: (currentValues, initialValues, mode) => currentValues.type === SERVICE && (mode === 'view' || mode === 'edit'),
                min: () => currentDate,
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.executionTerm;
                },
                disabled: (currentValues, initialValues, mode) => mode === 'view' || mode === 'edit',
            },
            {
                name: 'implementationReport',
                label: 'Отчет о выполнении',
                visible: (values) => values.type === SERVICE,
                grid: {sm: 12},
                calculatedValue: (values, mode) => {
                    if (mode === 'copy') return null;
                    return values.implementationReport;
                },
                disabled: true,
            },
            {
                name: 'file',
                label: 'Файл',
                type: 'file',
                visible: (values) => values.type === SERVICE ||
                    values.type === ON_PASS_MAKING || values.type === CARRYING_OUT_WORKS
                    || values.type === ON_PROPERTY_BRINGING,
                rowBreakBefore: true,
            },
            {
                name: 'workPlace',
                label: 'Место проведения',
                visible: (values) => values.type === CARRYING_OUT_WORKS,
                required: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'note',
                label: 'Примечание',
                grid: {sm: 12},
                visible: (values) => values.type !== SERVICE,
            },
            {
                name: 'managementCompanyComment',
                label: 'Комментарий УК',
                visible: (values, initialValues, mode) => mode === 'view' || mode === 'edit',
                disabled: true,
                grid: {sm: 12},
                initialValue: (values, mode) => {
                    if (mode === 'copy') {
                        return null;
                    }
                    return values.managementCompanyComment;
                },
            },
            {
                name: 'needDisableOrChangeSystem',
                label: 'Необходимость отключения или изменения работы инженерных систем и оборудования здания',
                type: formField.CHECKBOX,
                visible: (values) => values.type === CARRYING_OUT_WORKS,
            },
            {
                name: 'agreedEmployee',
                type: formField.AUTOCOMPLETE,
                label: 'Согласовал',
                visible: (currentValues, initialValues, mode) => mode === 'edit' || mode === 'view',
                entityName: 'employees',
                disabled: true,
                rowBreakBefore: true,
                initialValue: (values) => values.agreedEmployee,
            },
        ];
    }
}
